<template>
  <div class="page-container appstore_wrap">
    <store-header tabs="index" :showDoc="true" :defaultMarket="defaultMarketDomain"></store-header>
    <IndexHeader></IndexHeader>
    <IntroduceRainstore v-if="steps === 'index'"></IntroduceRainstore>
  </div>
</template>

<script>
import IntroduceRainstore from './components/introduceRainstore';
import IndexHeader from './components/indexheader';
export default {
  name: 'Index',
  components: { IntroduceRainstore, IndexHeader },
  data() {
    return {
      steps: 'index',
      endObj: {},
      activeShow: '',
      isAn: true
    };
  },
  watch: {
    $route(to) {
      this.steps = 'index';
    }
  },
  methods: {
    handleNext(endObj) {
      this.endObj = endObj;
      this.steps = 'auditStore';
    },
    setActiveStore(store) {
      if (this.activeShow == store) {
        this.activeShow = '';
      } else {
        this.activeShow = store;
      }
    }
  },
  created() {},
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/index/Index.vue